var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "transcript-recommendation-box rounded-sm pa-3" },
    [
      _c(
        "span",
        { staticClass: "d-inline-flex align-center mb-1" },
        [
          _c("icon-svg", {
            staticClass: "mr-2",
            attrs: { name: "lamp-on", size: "16", color: "var(--success)" }
          }),
          _c(
            "span",
            { staticClass: "az-text-primary az-size-12 font-semibold" },
            [_vm._v(_vm._s(_vm.title))]
          )
        ],
        1
      ),
      _c("p", { staticClass: "az-text-primary az-size-14 mb-0" }, [
        _vm._v(_vm._s(_vm.text))
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }